import { useMutation } from 'react-query';

import { binderManagementFileInputAxiosV2 } from '../../binderManagement.api';
import { useHandleError } from '../../binderManagement.utils';

export const useSubmitBDXCoverHolder = () => {
  const handleError = useHandleError({
    file: 'binderManagement.bdx.mutation.useSubmitBDX',
    warning: 'notification.bdx.submitFail',
  });

  return useMutation(
    async ({ groupId }) => {
      const data = await binderManagementFileInputAxiosV2.post('submit', { groupId });

      return data;
    },
    {
      onError: handleError,
    }
  );
};
